import type { FC } from 'react';
import { classes } from './Loader.st.css';
import { Loader as BaseLoader } from 'wix-style-react';

export const Loader: FC = () => {
  return (
    <div className={classes.wrapper}>
      <BaseLoader size="large" />
    </div>
  );
};
